<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28px" height="28px"
         viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
    </svg>

</template>

<script>
    export default {
        name: "defaultChapterIcon_svg"
    }
</script>




// WEBPACK FOOTER //
// src/common/components/svg/chapter/defaultChapterIcon_svg.vue